import { castArray, pick } from 'lodash';
import { RedirectionStateObject } from '../types';
import { tanstackUrlSearch, uriSafe } from '../utils';
import { newOptimizerRouteNames } from 'states/optimizers/optimizers.routes';

const ANGULAR_LIST_STATE = 'dashboard.triggers.optimizer-definitions';
const ANGULAR_WIZARD_STATE = 'dashboard.triggers.optimizer-wizard';

const LIST_PARAMS = ['sortBy', 'sortOrder', 'activeState', 'search', 'createdBy', 'updatedBy'];

const toListUrl = (params: Record<string, unknown>): `/360/${string}` =>
  `/360/optimizers${tanstackUrlSearch(pick(params, LIST_PARAMS))}`;

// The url gives strings; app-ui expects numbers.
const toNewUrl = ({ query, accountIds }: Record<string, unknown>): `/360/${string}` =>
  `/360/optimizers/new${tanstackUrlSearch({
    query,
    accountIds: accountIds ? castArray(accountIds).map(Number) : undefined,
  })}`;

const toEditUrl = (id: string | number): `/360/${string}` => `/360/optimizers/${uriSafe(id)}`;

export const optimizersRedirections: RedirectionStateObject = {
  [ANGULAR_LIST_STATE]: toListUrl,
  [newOptimizerRouteNames.definition]: toListUrl,
  [newOptimizerRouteNames.new]: toNewUrl,
  [ANGULAR_WIZARD_STATE]: params => (params.id ? toEditUrl(params.id) : toNewUrl(params)),
  [newOptimizerRouteNames.edit]: ({ id }) => toEditUrl(id),
};
